import { classNames } from 'utils/dom-helpers'
import 'react-dropzone-uploader/dist/styles.css'
import Translation from 'components/Translation'
import { ModalDataAttributes } from '../types'
import MoneyInput from 'components/MoneyInput'
import { FormErrors } from './types'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import {
    CycleTypes,
    MembershipType,
    RedemptionUnit,
    RenewalActions,
    TimePeriods,
    ValidityTypes,
} from 'types/membership'
import StepperInput from 'components/Stepper'
import { SetStateAction, useEffect, useRef, useState } from 'react'
import { Popup } from '@progress/kendo-react-popup'
import { useAppContext } from 'context/AppContext'
import { Switch } from '@headlessui/react'
import { getTranslation } from 'utils/language-helper'
import { Tooltip } from '@progress/kendo-react-tooltip'
import React from 'react'
import { InfoIcon } from 'utils/custom-icons'
import getConfig from 'next/config'

function RedemptionDetails({
    attributes,
    setAttributes,
    onCancel,
    onPrevious,
    onNext,
    disableBtn,
    setDisableBtn,
}: {
    attributes?: ModalDataAttributes
    setAttributes(r: ModalDataAttributes): void
    onCancel(): void
    onPrevious(): void
    onNext(): void
    disableBtn: boolean
    setDisableBtn: React.Dispatch<SetStateAction<boolean>>
}) {
    const { translations } = useAppContext()
    const form_errors: FormErrors =
        (attributes &&
            (attributes?.form_errors as unknown as FormErrors)) ||
        {}
    const [redemption, setRedemption] = useState<string>(
        (attributes?.redemption_unit as string) || RedemptionUnit.CLASSES
    )
    const what_anchor = useRef<HTMLButtonElement | null>(null)
    const what_anchor_cycle = useRef<HTMLButtonElement | null>(null)
    const what_anchor_renew = useRef<HTMLButtonElement | null>(null)

    const [cycle_type, setCycleType] = useState<string>(CycleTypes[0])
    const [validity_type, setValidityType] = useState<any>()
    const [time_period, setTimePeriod] = useState<any>()
    const [renewal_action, setRenewalAction] = useState<any>()

    const [popup_ref, setPopupRef] = useState<any>()
    const [popup_key, setPopupKey] = useState<string>('')

    const tooltip_ref = React.useRef<Tooltip>(null)
    const { NEXT_PUBLIC_STATIC_DOMAIN } = getConfig().publicRuntimeConfig

    useEffect(() => {
        if (attributes?.cycles == undefined || attributes?.cycles == -1) {
            setCycleType(CycleTypes[0])
        } else {
            setCycleType(CycleTypes[1])
        }
    }, [attributes?.cycles])

    useEffect(() => {
        if (!validity_type) {
            const validity_type =
                ValidityTypes.find(
                    (v) => v.value == attributes?.validity_type
                ) || ValidityTypes[0]
            setValidityType(validity_type)
            setAttributes({
                ...attributes,
                validity_type: validity_type.value,
            })
        }
    }, [attributes?.validity_type])

    useEffect(() => {
        if (!time_period) {
            const time_period =
                TimePeriods.find(
                    (t) => t.value == attributes?.time_period
                ) || TimePeriods[1]
            setTimePeriod(time_period)
            setAttributes({
                ...attributes,
                time_period: time_period.value,
            })
        }
    }, [attributes?.time_period])

    useEffect(() => {
        if (!renewal_action) {
            const renewal_action =
                RenewalActions.find(
                    (r) => r.value == attributes?.renewal
                ) || RenewalActions[1]
            setRenewalAction(renewal_action)
            setAttributes({
                ...attributes,
                renewal: renewal_action.value,
            })
        }
    }, [attributes?.renewal])

    function handleOnSelect(value: string) {
        if (value != redemption) {
            setRedemption(value)
            setAttributes({
                ...attributes,
                redemption_unit: value,
            })
        }
    }

    const getFooter = () => {
        const disable =
            (attributes?.price as number) < 0 ||
            (attributes?.initial_fee as number) < 0
        setDisableBtn(disable)
        return (
            <div className="mt-3 flex justify-end gap-3">
                <button
                    type="button"
                    className="border border-gray-300 rounded-lg py-1 inline-block btn-gap"
                    onClick={() => {
                        onCancel()
                    }}
                >
                    <Translation content_key="cancel" />
                </button>
                <div className="flex justify-end gap-3">
                    <button
                        type="button"
                        className="border border-gray-300 rounded-lg py-1 inline-block btn-gap"
                        onClick={() => {
                            onPrevious()
                        }}
                    >
                        <Translation content_key="previous" />
                    </button>
                    <button
                        disabled={disable}
                        type="button"
                        onClick={() => {
                            onNext()
                        }}
                        className={classNames(
                            `${disableBtn
                                ? 'bg-gray-400 cursor-not-allowed'
                                : ''
                            }`,
                            'group relative flex justify-center',
                            'btn-gap border border-transparent',
                            'rounded-md text-white',
                            'focus:outline-none',
                            attributes?.loading
                                ? 'bg-primary-light'
                                : attributes?.api_error
                                    ? 'bg-red-700 hover:bg-primary-dark focus:ring-2 focus:ring-offset-2 focus:ring-primary-light'
                                    : 'bg-primary hover:bg-primary-dark focus:ring-2 focus:ring-offset-2 focus:ring-primary-light'
                            // 'disabled: bg-gray-400 cursor-pointer'
                        )}
                    >
                        <Translation content_key="next" />
                    </button>
                </div>
            </div>
        )
    }

    return (
        <form method="POST" className="">
            <div className=" membership-title mb-5">
                
                <div className='flex items-center gap-2'>
                <Translation
                    render_as="h3"
                  
                    content_key="redemption_method_title"
                />
                <span
                    title={getTranslation('whats_this_desc', translations)}
                >
                    <InfoIcon />
                </span>
                </div>
              
                <Translation
                render_as="p"
             
                content_key="redemption_method_subtitle"
            />
           
                {/* <span
                    className="text-primary-light ml-3"
                    ref={what_anchor}
                    onMouseEnter={() => {
                        setPopupKey('whats_this_desc')
                        setPopupRef(what_anchor)
                    }}
                    onMouseLeave={() => setPopupKey('')}
                >
                    <i className="feather-info mr-1" />
                    <Translation
                        render_as="label"
                        content_key="whats_this"
                    />
                </span> */}
                  
            </div>
          
            <div className="lg:flex items-start gap-5 mb-6">
                <div
                    className={classNames(
                        'redemption-card gap-4 border rounded-lg ',
                        redemption == RedemptionUnit.CLASSES
                            ? 'border-primary-light'
                            : ''
                    )}
                    onClick={() => {
                        handleOnSelect(RedemptionUnit.CLASSES)
                    }}
                >
                    <div className="flex items-center gap-2">
                        <i
                            className={classNames(
                                'feather-briefcase text-xl',
                                redemption == RedemptionUnit.CLASSES
                                    ? 'text-primary-light'
                                    : ''
                            )}
                        />
                        <Translation
                            render_as="p"
                            className="text-primary text-base font-display"
                            content_key="services"
                        />
                        <span
                            title={getTranslation(
                                'services_method_desc',
                                translations
                            )}
                        >
                            <InfoIcon />
                        </span>
                        {/* <Translation
                                render_as="p"
                                className="text-gray-400"
                                content_key="services_method_desc"
                            /> */}
                    </div>
                    {redemption == RedemptionUnit.CLASSES && (
                        <>
                            <StepperInput
                                default_value={
                                    attributes?.redemption_services as number
                                }
                                max_value={999}
                                helper_text={
                                    attributes?.allow_unlimited
                                        ? translations[
                                              'memberships.no_limit'
                                          ]
                                        : translations['class_appointments']
                                }
                                onChange={(v: number) => {
                                    setAttributes({
                                        ...attributes,
                                        redemption_services: v,
                                    })
                                }}
                                hide_input={
                                    attributes?.allow_unlimited as boolean
                                }
                                disabled={
                                    attributes?.allow_unlimited as boolean
                                }
                            />
                            <div className="flex flex-row items-center">
                                <Switch
                                    name="allow_unlimited"
                                    id="allow_unlimited"
                                    checked={
                                        attributes?.allow_unlimited as boolean
                                    }
                                    onChange={() =>
                                        setAttributes({
                                            ...attributes,
                                            allow_unlimited:
                                                !attributes?.allow_unlimited,
                                        })
                                    }
                                    className={`${
                                        (attributes?.allow_unlimited as boolean)
                                            ? 'bg-primary-light'
                                            : 'bg-gray-300'
                                    }
                                    block relative inline-flex h-5 w-10 
                                    border-2 border-transparent rounded-full cursor-pointer 
                                    transition-colors ease-in-out duration-200 
                                    focus:outline-none focus-visible:ring-2 
                                    focus-visible:ring-white focus-visible:ring-opacity-75`}
                                >
                                    <Translation
                                        className="sr-only"
                                        content_key="memberships.allow_unlimited_redemption"
                                        render_as="span"
                                    />
                                    <span
                                        aria-hidden="true"
                                        className={`${
                                            (attributes?.allow_unlimited as boolean)
                                                ? 'translate-x-5'
                                                : 'translate-x-0'
                                        }
                                    pointer-events-none inline-block h-4 w-4 
                                    rounded-full bg-white shadow-lg transform ring-0 
                                    transition ease-in-out duration-200`}
                                    />
                                </Switch>
                                <Translation
                                    render_as="label"
                                    content_key="memberships.allow_unlimited_redemption"
                                    className="my-auto ml-2"
                                />
                            </div>
                        </>
                    )}
                </div>
                <div
                    className={classNames(
                        'redemption-card gap-4 border rounded-lg ',
                        redemption == RedemptionUnit.AMOUNT
                            ? 'border-primary-light'
                            : ''
                    )}
                    onClick={() => {
                        handleOnSelect(RedemptionUnit.AMOUNT)
                    }}
                >
                    <div className="flex items-center gap-2">
                        <img
                            className="w-5 h-5"
                            src={
                                redemption == RedemptionUnit.AMOUNT
                                    ? `https://${NEXT_PUBLIC_STATIC_DOMAIN}/images/amount-credits-active.svg`
                                    : `https://${NEXT_PUBLIC_STATIC_DOMAIN}/images/amount-credits.svg`
                            }
                            alt="Amount Credits"
                        />
                        <Translation
                            render_as="p"
                            className="text-primary text-base font-display"
                            content_key="fixed_amount"
                        />

                        <span
                            title={getTranslation(
                                'fixed_amount_method_desc',
                                translations
                            )}
                        >
                            <InfoIcon />
                        </span>

                        {/* <Translation
                                render_as="p"
                                className="text-gray-400"
                                content_key="fixed_amount_method_desc"
                            /> */}
                    </div>
                    {redemption == RedemptionUnit.AMOUNT && (
                        <>
                            <StepperInput
                                default_value={
                                    attributes?.redemption_amount as number
                                }
                                onChange={(v: number) => {
                                    setAttributes({
                                        ...attributes,
                                        redemption_amount: v,
                                    })
                                }}
                            />
                            <div className="flex flex-row items-center">
                                <Switch
                                    name="allow_unlimited"
                                    id="allow_unlimited"
                                    checked={
                                        attributes?.apply_member_discount as boolean
                                    }
                                    onChange={() =>
                                        setAttributes({
                                            ...attributes,
                                            apply_member_discount:
                                                !attributes?.apply_member_discount,
                                            service_discount_percentage:
                                                attributes?.apply_member_discount
                                                    ? 0
                                                    : 10,
                                        })
                                    }
                                    className={`${
                                        attributes?.apply_member_discount
                                            ? 'bg-primary-light'
                                            : 'bg-gray-300'
                                    }
                                    block relative inline-flex h-5 w-10 
                                    border-2 border-transparent rounded-full cursor-pointer 
                                    transition-colors ease-in-out duration-200 
                                    focus:outline-none focus-visible:ring-2 
                                    focus-visible:ring-white focus-visible:ring-opacity-75 my-auto`}
                                >
                                    <Translation
                                        className="sr-only"
                                        content_key="memberships.allow_unlimited_redemption"
                                        render_as="span"
                                    />
                                    <span
                                        aria-hidden="true"
                                        className={`${
                                            attributes?.apply_member_discount
                                                ? 'translate-x-5'
                                                : 'translate-x-0'
                                        }
                                    pointer-events-none inline-block h-4 w-4 
                                    rounded-full bg-white shadow-lg transform ring-0 
                                    transition ease-in-out duration-200`}
                                    />
                                </Switch>
                                <div className="flex flex-row gap-2 items-center whitespace-normal ml-2 leading-none">
                                    <Translation
                                        render_as="label"
                                        content_key="memberships.apply_member_discount"
                                    />
                                    <span
                                        title={getTranslation(
                                            'memberships.apply_member_discount_tooltip',
                                            translations
                                        )}
                                    >
                                        <InfoIcon />
                                    </span>
                                    {/* <i
                                        className="feather-info ml-1"
                                        title={getTranslation(
                                            'memberships.apply_member_discount_tooltip',
                                            translations
                                        )}
                                        onMouseOver={(event) =>
                                            tooltip_ref.current &&
                                            tooltip_ref.current.handleMouseOver(
                                                event
                                            )
                                        }
                                        onMouseOut={(event) =>
                                            tooltip_ref.current &&
                                            tooltip_ref.current.handleMouseOut(
                                                event
                                            )
                                        }
                                    />
                                    <Tooltip
                                        ref={tooltip_ref}
                                        anchorElement="target"
                                        position="top"
                                        content={(props) => (
                                            <div className="w-60 whitespace-normal">
                                                <Translation
                                                    content_key="memberships.apply_member_discount_tooltip"
                                                    render_as="span"
                                                />
                                            </div>
                                        )}
                                    /> */}
                                </div>
                                
                            </div>
                            <div className="ml-2 relative">
                                    <input
                                        disabled={
                                            !attributes?.apply_member_discount
                                        }
                                        type="number"
                                        className="rounded-lg disabled:cursor-not-allowed disabled:bg-[#F9F9F9]"
                                        style={{
                                            border: '1px solid #DDE2E5',
                                        }}
                                        value={
                                            attributes?.apply_member_discount
                                                ? (attributes?.service_discount_percentage as number)
                                                : '-'
                                        }
                                        onChange={(e) => {
                                            setAttributes({
                                                ...attributes,
                                                service_discount_percentage:
                                                    e.target.value,
                                            })
                                        }}
                                    />
                                    <span
                                        className={classNames(
                                            'absolute right-0 text-xl inset-y-0 mt-2 mr-2',
                                            attributes?.apply_member_discount
                                                ? 'text-gray-400'
                                                : 'text-primary-light'
                                        )}
                                    >
                                        %
                                    </span>
                                </div>
                        </>
                    )}
                </div>
                <div
                    className={classNames(
                        'redemption-card gap-4 border rounded-lg ',
                        redemption == RedemptionUnit.TIME
                            ? 'border-primary-light'
                            : ''
                    )}
                    onClick={() => {
                        handleOnSelect(RedemptionUnit.TIME)
                    }}
                >
                    <div className="flex items-center gap-2">
                        <i
                            className={classNames(
                                'feather-clock text-xl',
                                redemption == RedemptionUnit.TIME
                                    ? 'text-primary-light'
                                    : ''
                            )}
                        />
                        
                            <Translation
                                render_as="p"
                                className="text-primary text-base font-display"
                                content_key="time"
                            />
                            <span
                            title={getTranslation(
                                'time_method_desc',
                                translations
                            )}
                        >
                            <InfoIcon />
                        </span>
                            {/* <Translation
                                render_as="p"
                                className="text-gray-400"
                                content_key="time_method_desc"
                            /> */}
                        </div>
                    {redemption == RedemptionUnit.TIME && (
                        <div className='w-[225px]'>
                        <StepperInput
                            default_value={
                                attributes?.redemption_minutes as number
                            }
                            helper_text={translations['minutes']}
                            onChange={(v: number) => {
                                setAttributes({
                                    ...attributes,
                                    redemption_minutes: v,
                                })
                            }}
                        />
                        </div>
                    )}
                </div>
            </div>
            <Translation
                render_as="div"
                className="text-primary text-lg font-medium font-display mb-2"
                content_key="pricing_and_renewal"
            />
            <div className="lg:flex items-stretched gap-5 mb-6">
                <fieldset className="w-full lg:w-1/3">
                    <Translation
                        render_as="label"
                        className="block text-sm"
                        htmlFor="price"
                        content_key="price"
                    />
                    <MoneyInput
                        id="price"
                        className={classNames(
                            'px-6 py-1 mt-1 focus:ring-0 focus:border-transparent block w-full rounded-md',
                            form_errors.price
                                ? 'border-red-300 bg-red-100'
                                : ''
                        )}
                        defaultValue={(attributes?.price as number) || 0}
                        onMoneyChange={(v: string) => {
                            setAttributes({
                                ...attributes,
                                price: v,
                            })
                        }}
                    />
                </fieldset>
                {attributes?.membership_type === MembershipType.Package ? (
                    <fieldset className="w-full lg:w-1/3">
                        <Translation
                            render_as="label"
                            className="block text-sm"
                            htmlFor="validity_value"
                            content_key="validity"
                        />
                        <div className="flex gap-2">
                            <div
                                className={classNames(
                                    'w-1/2 mt-1 relative rounded-md shadow-sm border-gray-300 hover:ing-primary-light hover:border-primary-light focus:ring-0 focus:border-none'
                                )}
                                style={{ borderWidth: '1px' }}
                            >
                                <input
                                    id="validity_value"
                                    type="number"
                                    min="1"
                                    max="999"
                                    className={classNames(
                                        'py-1 mt-1 focus:ring-0 focus:border-transparent block w-full shadow-sm border-gray-300 rounded-md',
                                        'hover:ring-primary-light hover:border-primary-light',
                                        'focus:ring-primary-light focus:border-primary-light'
                                    )}
                                    defaultValue={
                                        (attributes?.validity_value as number) ||
                                        0
                                    }
                                    onChange={(e) => {
                                        setAttributes({
                                            ...attributes,
                                            validity_value: e.target.value,
                                        })
                                    }}
                                />
                            </div>
                            <DropDownList
                                id="validity_type"
                                className="bg-white py-1 mt-1 block w-1/2 shadow-sm border border-gray-300 rounded-md text-base"
                                iconClassName="feather-chevron-down"
                                popupSettings={{
                                    className: 'z-[102]',
                                }}
                                data={ValidityTypes}
                                value={validity_type}
                                textField="text"
                                dataItemKey="value"
                                onChange={(e) => {
                                    const selected_item = e.target.value
                                    setValidityType(selected_item)
                                    setAttributes({
                                        ...attributes,
                                        validity_type: selected_item.value,
                                    })
                                }}
                            />
                        </div>
                    </fieldset>
                ) : (
                    <fieldset className="w-full lg:w-1/3">
                        <Translation
                            render_as="label"
                            className="block text-sm"
                            htmlFor="time_period"
                            content_key="time_period"
                        />
                        <DropDownList
                            id="time_period"
                            className="bg-white py-1 mt-1 block w-full shadow-sm border border-gray-300 rounded-md text-base"
                            popupSettings={{
                                className: 'z-[102]',
                            }}
                            iconClassName="feather-chevron-down"
                            data={TimePeriods}
                            value={time_period}
                            textField="text"
                            dataItemKey="value"
                            onChange={(e) => {
                                const selected_item = e.target.value
                                setTimePeriod(selected_item)
                                setAttributes({
                                    ...attributes,
                                    time_period: selected_item.value,
                                })
                            }}
                        />
                    </fieldset>
                )}
                <fieldset className="w-full lg:w-1/3">
                    <Translation
                        render_as="label"
                        className="block text-sm"
                        htmlFor="initial_fee"
                        content_key="initial_fee"
                    />
                    <MoneyInput
                        id="initial_fee"
                        className={classNames(
                            'px-6 py-1 mt-1 focus:ring-0 focus:border-transparent block w-full rounded-md',
                            form_errors.price
                                ? 'border-red-300 bg-red-100'
                                : ''
                        )}
                        defaultValue={
                            (attributes?.initial_fee as number) || 0
                        }
                        onMoneyChange={(v: string) => {
                            setAttributes({
                                ...attributes,
                                initial_fee: v,
                            })
                        }}
                    />
                </fieldset>
            </div>
            {attributes?.membership_type ===
                MembershipType.Subscription && (
                <div className="grid lg:grid-cols-2 gap-5 pb-6 mb-6">
                    <div className="">
                        <div className="flex items-center mb-2">
                            <Translation
                                render_as="div"
                                className="text-primary-light text-xl font-medium font-display"
                                content_key="cycles"
                            />
                            <span
                                className="text-primary-light ml-3"
                                ref={what_anchor_cycle}
                                onMouseEnter={() => {
                                    setPopupKey('whats_this_cycle')
                                    setPopupRef(what_anchor_cycle)
                                }}
                                onMouseLeave={() => setPopupKey('')}
                            >
                                <i className="feather-info mr-1" />
                                <Translation
                                    render_as="label"
                                    content_key="whats_this"
                                />
                            </span>
                        </div>

                        <Translation
                            render_as="div"
                            className="text-basis font-basis text-gray-400 mb-3"
                            content_key="cycles_desc"
                        />
                        <Translation
                            render_as="label"
                            htmlFor="cycle_type"
                            className="block text-base"
                            content_key="number_of_cycles"
                        />
                        <DropDownList
                            id="cycle_type"
                            className="bg-white py-2.5 mt-1 block w-full shadow-sm border border-gray-300 rounded-md text-base"
                            popupSettings={{
                                height: 'h-full',
                                className: 'z-[102]',
                            }}
                            iconClassName="feather-chevron-down"
                            data={CycleTypes}
                            value={cycle_type}
                            onChange={(e) => {
                                setCycleType(e.target.value)
                                setAttributes({
                                    ...attributes,
                                    cycles:
                                        e.target.value == CycleTypes[0]
                                            ? -1
                                            : 0,
                                })
                            }}
                        />
                        <div
                            className={classNames(
                                'mt-1 relative rounded-md shadow-sm border-gray-300 hover:ing-primary-light hover:border-primary-light focus:ring-0 focus:border-none',
                                cycle_type == CycleTypes[1]
                                    ? 'block'
                                    : 'hidden'
                            )}
                            style={{ borderWidth: '1px' }}
                        >
                            <input
                                id="cycles"
                                type="number"
                                min="0"
                                max="999"
                                className={classNames(
                                    'py-3 mt-1 focus:ring-0 focus:border-transparent block w-full shadow-sm border-gray-300 rounded-md',
                                    'hover:ring-primary-light hover:border-primary-light',
                                    'focus:ring-primary-light focus:border-primary-light'
                                )}
                                value={attributes?.cycles as string}
                                onChange={(e) => {
                                    setAttributes({
                                        ...attributes,
                                        cycles: e.target.value,
                                    })
                                }}
                            />
                        </div>
                    </div>
                    <div className="">
                        <div className="flex items-center mb-2">
                            <Translation
                                render_as="div"
                                className="text-primary-light text-xl font-medium font-display"
                                content_key="renewal"
                            />
                            <span
                                className="text-primary-light ml-3"
                                ref={what_anchor_renew}
                                onMouseEnter={() => {
                                    setPopupKey('whats_this_renew')
                                    setPopupRef(what_anchor_renew)
                                }}
                                onMouseLeave={() => setPopupKey('')}
                            >
                                <i className="feather-info mr-1" />
                                <Translation
                                    render_as="label"
                                    content_key="whats_this"
                                />
                            </span>
                        </div>

                        <Translation
                            render_as="div"
                            className="text-basis font-basis text-gray-400 mb-3"
                            content_key="renewal_desc"
                        />
                        <Translation
                            render_as="label"
                            className="block text-base"
                            htmlFor="renewal"
                            content_key="subscription_renewal_action"
                        />
                        <DropDownList
                            id="renewal"
                            className="bg-white py-2.5 mt-1 block w-full shadow-sm border border-gray-300 rounded-md text-base"
                            popupSettings={{
                                height: 'h-full',
                                className: 'z-[102]',
                            }}
                            iconClassName="feather-chevron-down"
                            data={RenewalActions}
                            value={renewal_action}
                            textField="text"
                            dataItemKey="value"
                            onChange={(e) => {
                                const selected_item = e.target.value
                                setRenewalAction(selected_item)
                                setAttributes({
                                    ...attributes,
                                    renewal: selected_item.value,
                                })
                            }}
                        />
                    </div>
                </div>
            )}
            {getFooter()}
            <Popup
                anchor={popup_ref?.current}
                show={popup_key != ''}
                animate={false}
                popupAlign={{
                    horizontal: 'left',
                    vertical: 'top',
                }}
                popupClass={
                    'bg-black text-white shadow-lg rounded-xl w-96 px-5 py-3 mt-2'
                }
                className="z-[102]"
            >
                <Translation render_as="p" content_key={popup_key} />
            </Popup>
        </form>
    )
}

export default RedemptionDetails
